import { InlineAlert } from '@xo-union/tk-component-alerts';
import { Question } from '../../gds-api-client';
import { Form, FormikProps } from 'formik';
import React, { useContext } from 'react';

import { ApiClientsContext, EventType } from '../components/ApiClientsContext';
import { ErrorContext } from '../components/ErrorContext';
import { Meals, WeddingWebsiteForm } from '../components/Form';
import { DetailsForm } from './DetailsForm';
import { FormValues } from './RightRailForm';
import { ScheduleOfEventsForm } from './ScheduleOfEventsForm';

export interface EventLocation {
  name?: string | null;
  street1?: string | null;
  street2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  country?: string | null;
}

export interface LegacyEvent {
  id: string;
  name: string;
  type: EventType;
  date?: string;
  time?: string;
  endTime?: string;
  attire?: string;
  notes?: string;
  questions?: Question[] | null;
  requireRsvp?: boolean;
  sameVenue?: boolean;
  location?: EventLocation | null;
  visible?: boolean;
  weddingId: string;
  createdAt: string;
  updatedAt: string;
  image?: any;
}

interface Props extends FormikProps<FormValues> {
  hasWWS: boolean;
}

const EventForm: React.FC<Props> = ({ setFieldValue, values, hasWWS }) => {
  const { errors } = useContext(ErrorContext);
  const { eventType: type } = useContext(ApiClientsContext);

  return (
    <Form>
      {errors && <InlineAlert type="error">{errors.unknown}</InlineAlert>}
      <DetailsForm setFieldValue={setFieldValue} values={values} />
      {type === 'Ceremony' && <ScheduleOfEventsForm values={values} />}
      <WeddingWebsiteForm
        customEvent={type === 'Ceremony'}
        hasWWS={hasWWS}
        setFieldValue={setFieldValue}
        namePrefix="events[0]."
      />
      <Meals namePrefix="events[0]." />
    </Form>
  );
};

export default EventForm;
